import styled from "styled-components";

const KidsHeroWrap = styled.div`
  background-color: #ffffff;
  //background-color: #f4f2f5;
  padding: 32px 0;
  text-align: center;
  h4 {
    margin-top: 0px;
    font-size: 45px;
    font-weight: 700;
    letter-spacing: 3px;
    text-transform: uppercase;
    margin-bottom: 0px;
  }
`
export default KidsHeroWrap